import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import * as Yup from "yup";
import { submitEnclosureFiles, submitRepresentatives } from "../../auth/services/privateapicalling";
// import { ar } from "react-router/dist/development/route-data-CGHGzi13";
import { toast } from "react-toastify";


interface GuarantorsProps {
  onNext: (data: any) => void;
  onPrev: () => void;
  isGurantorFilled: boolean;
  fetchApplicationIfExist: () => Promise<void>;
  applicationId: string | null;
  existData: any;
  fetchApplicationExistenceCheck: () => Promise<void>;
}

interface DocumentDetail {
  [key: string]: {
    docId: string;
    docName: string;
    fileName: string;
  };
}

interface Guarantor {
  name: string;
  address: string;
  panCardNo: string;
  docDetail: { 
    docId: string;
    documentName: string;
    fileName: string;
  }[];
}

const Guarantors: React.FC<GuarantorsProps> = ({
  onNext,
  onPrev,
  fetchApplicationIfExist,
  applicationId,
  existData,
  fetchApplicationExistenceCheck
}) => {
  const token = useSelector((state: any) => state.auth.token);
  const userdetails = useSelector((state: any) => state.auth.userDetails);
  const language = useSelector((state: any) => state.auth.language);
  const formLanguage = useSelector((state: any) => state.auth.formLanguage);

  const applicationIdRedux = useSelector((state: any) => state.auth.applicationId);
  const appId = userdetails.applicationId || applicationIdRedux;
  const [files, setFiles] = useState<{ [key: string]: File | null }>({});
  const [selectedLang, setSelectedLang] = useState<string>("");
  const fields = ["guarantorPhoto", "guarantorPanCard", "guarantorSignature"];
  const [isChecked, setIsChecked] = useState(false);
  const [errorr, setErrorr] = useState<{ [key: string]: string }>({});
  const [uploadingFields, setUploadingFields] = useState(false);
  const [loading, setLoading] = useState(false);

  const today = new Date();
  const formattedDate = `${String(today.getDate()).padStart(2, '0')}-${String(today.getMonth() + 1).padStart(2, '0')}-${today.getFullYear()}`;
  
  //.log('appId from guarantor',existData)

  const garantorArray = ["guarantorPhoto_1","guarantorPhoto_2","guarantorPanCard_1","guarantorPanCard_2","guarantorSignature_1","guarantorSignature_2"]

  // const [guarantors, setGuarantors] = useState<Guarantor[]>(
  //   existData?.guarantorDetails?.length > 0
  //     ? existData.guarantorDetails
  //     : [
  //         { name: "", address: "", panCardNo: "", docDetail: [] },
  //         { name: "", address: "", panCardNo: "", docDetail: [] },
  //       ]
  // );

  const [guarantorDeclarationUploaded, setGuarantorDeclarationUploaded] = useState(false);
  const [guarantorDeclarations, setGuarantorDeclarations] = useState<any>({});


  const [guarantors, setGuarantors] = useState<Guarantor[]>(
    existData?.guarantorDetails?.length > 0
      ? existData.guarantorDetails.map((g) => ({
          ...g,
          docDetail: g.docDetail ?? [], // Ensure docDetail is always an array
        }))
      : [
          { name: "", address: "", panCardNo: "", docDetail: [] },
          { name: "", address: "", panCardNo: "", docDetail: [] },
        ]
  );
const guarantorLabels = {
  "guarantorPhoto": "Guarantors Photo",
  "guarantorSignature": "Guarantors Signature", 
  "guarantorPanCard": "Guarantors Pan Card"
};
  
  useEffect(() => {
    if (existData?.guarantorDetails?.length > 0) {
      setGuarantors(existData.guarantorDetails);
    } else if (existData?.docs?.length > 0) {
      const newGuarantors = [
        { name: "", address: "", panCardNo: "", docDetail:[]},
        { name: "", address: "", panCardNo: "", docDetail: []},
      ];

      
      let declarationUploaded = false;

      existData.docs.forEach((doc: any) => {

        if (doc.documentName === "guarantorDeclaration") {
          declarationUploaded = true;
        }

        const matchingField = garantorArray.find((field) => doc.documentName.includes(field));
        if (matchingField) {
          const index = matchingField.endsWith("_1") ? 0 : 1;
          if (!Array.isArray(newGuarantors[index].docDetail)) {
            newGuarantors[index].docDetail = [];
          }
          newGuarantors[index].docDetail.push({
            docId: doc.id || "",
            documentName: doc.documentName || "",
            fileName: doc.fileName || "",
          });
        }
      });

    
      //.log('new guarantor', newGuarantors);
      setGuarantors(newGuarantors);
    
      //.log('Updated guarantors:', newGuarantors);

      if (declarationUploaded) {
        setGuarantorDeclarationUploaded(true);
      }
    }
  }, [existData]);

//.log('guarantors test',existData)

// useEffect(()=>{
//   setGuarantors(existData?.guarantorDetails)
// },[])

//.log('guarantors test',guarantors)
 
  // const [errors, setErrors] = useState<{ [key: number]: { [key: string]: string } }>({});
  // const [errors, setErrors] = useState<{ guarantors: { name?: string; panCardNo?: string; address?: string  }[] }>({
  //   guarantors: [],
  // });
  
  const [errors, setErrors] = useState<{
    guarantors: {
      name?: string;
      panCardNo?: string;
      address?: string;
      docDetail?: string[]; // This stores missing document errors
    }[];
 
  }>({
    guarantors: [],
  });

  const [fileError,setFileError] = useState({});;
  const validationFileSchema = Yup.object().shape({
      uploadedFiles: Yup.object().shape(
        fields.reduce((acc, field) => {
          acc[field] = Yup.mixed()
            .test("required", `${field} is required`, (value) => value && value instanceof File)
            .required(`${field} is required`);
            //.log('acc',acc)
          return acc;
        }, {})
  
      ),
    });
   
  const validateAndSubmit = async () => {
    try {
      //.log('files', files); // Log the actual files state
      const validFiles = Object.keys(files).reduce((acc, key) => {
        if (files[key] || (existData && existData.docs?.find((doc: any) => doc.documentName === key))) {
          acc[key] = files[key] || null; // Include existing files
        }
        return acc;
      }, {});

      //.log('validFiles', validFiles); // Log only valid files
      await validationFileSchema.validate({ uploadedFiles: validFiles }, { abortEarly: false });
      //.log("All files are valid. Submitting...", validFiles);
      setFileError({});
      return true; // Indicate successful validation
    } catch (err) {
      const validationErrors: { [key: string]: string } = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          if (error.path) {
            const fieldName = error.path.split(".")[1];
            if (!files[fieldName] && !(existData && existData.docs?.find((doc: any) => doc.documentName === fieldName))) {
              // Only set error if the file doesn't exist and isn't already uploaded
              validationErrors[fieldName] = error.message;
            }
          }
        });
      }
      setFileError(validationErrors);
      //.error("Validation errors:", validationErrors);
      return false; // Indicate validation failure
    }
  };
  
  const validationSchema = Yup.object().shape({

    guarantors: Yup.array().of(
        Yup.object().shape({
          name: Yup.string()
            .matches(/^[A-Za-z\s]+$/, "Only alphabets and spaces are allowed, no special characters")
            .max(40, "Name must not exceed 40 characters including spaces")
            .required("Name is required"),
            panCardNo: Yup.string()
                  .matches(
                    /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                    "Invalid PAN Card Number (e.g., ABCDE1234F)"
                  )
                  .required("PAN Card Number is required"),
            address:  Yup.string().matches( /^[A-Za-z0-9\s+\/'",.\-_@#$%&*()!?:;]+$/,
                "Only alphabets, spaces,numbers and the following special characters are allowed: + / ' , ."
              ).max(100, "Address must not exceed 100 characters")
            .required("Address is required"),
            docDetail: Yup.array()
        .of(
          Yup.object().shape({
            docId: Yup.string().required("Document ID is required"),
            documentName: Yup.string().required("Document Name is required"),
            fileName: Yup.string().required("File Name is required"),
          })
        )
        .test("required-documents", "All required documents must be uploaded", function (docDetail) {
          const requiredDocs = ["guarantorPhoto", "guarantorPanCard", "guarantorSignature"];
          const uploadedDocs = docDetail?.map(doc => doc.documentName) || [];
 
          const missingDocs = requiredDocs.filter(doc => !uploadedDocs.includes(doc));

          if (missingDocs.length > 0) {
            throw this.createError({
              path: "docDetail",
              message: `${missingDocs.join(", ")} is required`,
            });
          }
 
          return true;
        }),
 
        })
      )
    });


  const validationForm = async () => {
    try {
     
      await validationSchema.validate({ guarantors }, { abortEarly: false });
      setErrors({ guarantors: [] });
      return true;
    } catch (err: any) {
      // 1. initialize errors array
      const newErrors: any = {
        guarantors: guarantors.map(() => ({})),
      };
  
      // 2. collect Yup field‑level errors
      if (err.inner && err.inner.length > 0) {
        err.inner.forEach((error: any) => {
          if (!error.path) return;
          const m = error.path.match(/guarantors\[(\d+)]\.(\w+)/);
          if (!m) return;
          const idx = parseInt(m[1], 10);
          const field = m[2];
          newErrors.guarantors[idx][field] = error.message;
        });
      } else if (err.path) {
        const m = err.path.match(/guarantors\[(\d+)]\.(\w+)/);
        if (m) {
          const idx = parseInt(m[1], 10);
          const field = m[2];
          newErrors.guarantors[idx][field] = err.message;
        }
      }
  
      // 3. Additional Validation for `docDetail` with suffix stripping
      guarantors.forEach((g, index) => {
        const requiredDocs = [
          "guarantorPhoto",
          "guarantorPanCard",
          "guarantorSignature",
        ];
        const uploadedBaseNames =
          g.docDetail?.map((doc) =>
            // strip trailing "_<digits>"
            doc.documentName.replace(/_\d+$/, "")
          ) || [];
  
        const missing = requiredDocs.filter(
          (base) => !uploadedBaseNames.includes(base)
        );
  
        if (missing.length > 0) {
          newErrors.guarantors[index].docDetail = `Missing documents: ${missing.join(
            ", "
          )}`;
        }
      });

     
      setErrors(newErrors);
  
      // 4. decide validity
      const hasAnyError = newErrors.guarantors.some(
        (errObj: any) => Object.keys(errObj).length > 0
      )|| !!newErrors.guarantorDeclaration;
      return !hasAnyError;
    }
  };
  
  
  const handleInputChange = (index: number, e: React.ChangeEvent<HTMLInputElement>) => {
    const newGuarantors = [...guarantors];
    newGuarantors[index] = { ...newGuarantors[index], [e.target.name]: e.target.value };
    setGuarantors(newGuarantors);

    setErrors((prevErrors) => ({
      ...prevErrors,
      [index]: { ...prevErrors[index], [e.target.name]: "" },
    }));
  };


  const handleDownload = (fileNames: string[]) => {
    fileNames.forEach((fileName) => {
      const fileUrl = `/${fileName}`; 
      const link = document.createElement("a");
      link.href = fileUrl;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  // const handleFileChange = async (
  //   e: React.ChangeEvent<HTMLInputElement>,
  //   fieldName: string,
  //   index: number,
  //   docId?: string | null
  // ) => {
  //   const file = e.target.files?.[0] || null;
  
  //   if (!file) {
  //     return;
  //   }
  
  //   setFiles((prev) => ({ ...prev, [fieldName]: file }));
  
  //   const docData = await handleUpload(fieldName, file, docId);
    
  //   if (docData?.success==true && docData.data) {
  //     const fileInfo = docData.data;
  
  //     setGuarantors((prev) =>
  //       prev.map((g, i) => {
  //         if (i !== index) return g;
  
  //         if (fieldName === "guarantorDeclaration") {
  //           setGuarantorDeclarationUploaded(true);
  //           return {
  //             ...g,
  //             guarantorDeclaration: {
  //               docID: fileInfo?.id || "",
  //               documentName: fileInfo?.documentName || fieldName || "",
  //               fileName: fileInfo?.fileName || file.name || "",
  //             },
  //           };
  //         }
  
  //         // Other document types
  //         return {
  //           ...g,
  //           docDetail: [
  //             ...(g.docDetail?.filter((doc) => doc.documentName !== fieldName) || []),
  //             {
  //               docID: fileInfo?.id || "",
  //               documentName: fileInfo?.documentName || fieldName || "",
  //               fileName: fileInfo?.fileName || file.name || "",
  //             },
  //           ],
  //         };
  //       })
  //     );
  //   } 
  // };

  const handleFileChange = async (
    e: React.ChangeEvent<HTMLInputElement>,
    fieldName: string,
    index: number,
    docId?: string | null
  ) => {
    const file = e.target.files?.[0] || null;
  
    if (!file) return;
  
    setFiles((prev) => ({ ...prev, [fieldName]: file }));
  
    const docData = await handleUpload(fieldName, file, docId);
  
    if (docData?.success === true && docData.data) {
      const fileInfo = docData.data;
  
      if (fieldName === "guarantorDeclaration") {

        setGuarantorDeclarations({
          docId: fileInfo?.id,
          documentName: fileInfo?.documentName,
          fileName: fileInfo?.fileName,
        });
  
        setGuarantorDeclarationUploaded(true);
        return;
      }
  
      // Other document types
      setGuarantors((prev) =>
        prev.map((g, i) =>
          i === index
            ? {
                ...g,
                docDetail: [
                  ...(g.docDetail?.filter((doc) => doc.documentName !== fieldName) || []),
                  {
                    docId: fileInfo?.id || "",
                    documentName: fileInfo?.documentName || fieldName,
                    fileName: fileInfo?.fileName || file.name,
                  },
                ],
              }
            : g
        )
      );
    } 
  };

  const handleUpload = async (fieldName: string, file: File, docId?: string | null) => {
    //.log('user detail app id' ,appId,fieldName)
    // if (!files[fieldName]) return;
    const formData = new FormData();
    formData.append("file", file as Blob);
    formData.append("documentName", fieldName);
    formData.append("applicationId", applicationId);
    //.log('form data',formData)
    try {
      // setUploading((prev) => ({ ...prev, [fieldName]: true }));
      setUploadingFields(true);
      const res = await submitEnclosureFiles(formData, token,docId);
      // fetchApplicationExistenceCheck();
        if(res.success==true)
          {
            toast.success(res?.message,{position: "top-right", autoClose: 3000,});
          }
          else{
            toast.error(res?.message,{position: "top-right", autoClose: 3000,});
          }
      return res;
      // if (res.success) { // Assuming response contains success flag
      //   // setUploadStatus((prev) => {
      //   //   const newStatus = { ...prev, [fieldName]: true };
      //   //   localStorage.setItem("uploadStatus", JSON.stringify(newStatus)); // Save to localStorage
      //   //   return newStatus;
      //   // });
      //   //.log(`${fieldName} uploaded successfully`);
      // } else {
      //   alert("File upload failed");
      // }
     
    } catch (error) {
      // alert("File upload failed");
      toast.error("File upload failed", {position: "top-right", autoClose: 3000,});
      
    } finally {
      // setUploading((prev) => ({ ...prev, [fieldName]: false }));
      setUploadingFields(false);

    }
  };

  const toastCooldown = useRef(false);
    
  const showErrorToast = (message: string) => {
    if (toastCooldown.current) return; // Skip if still in cooldown
  
    toast.error(message,{position: "top-right", autoClose: 3000,});
    toastCooldown.current = true;
  
    // Reset cooldown after 3 seconds
    setTimeout(() => {
      toastCooldown.current = false;
    }, 3000);
  };
  
  const handleNext = async () => {
 
    const isValid = await validationForm();
    
    if (!isValid) {
      //.log("Validation failed. Fix errors before submitting.");
      showErrorToast("Please fill all required details.");

      return;
    }

    if( !guarantorDeclarationUploaded) {
      setErrorr({ gurantorDeclaration: "Guarantor declaration is required." });
      return;
    }

    if (!isChecked) {
      setErrorr({ electionContest: "Required to accept" });
      return ;
    }

  

    try {
      const data = {
        applicationId: applicationId,
        guarantorDetails: guarantors,
      };
     
      setLoading(true);
      const res = await submitRepresentatives(data, token);
      setLoading(false);
    
      onNext("");
      

    } catch (error) {
      //.error("Error submitting data:", error);
    }
  };
  //.log('existData declaratiom',existData)

  useEffect(()=>{
    fetchApplicationExistenceCheck();
     const docId =
      existData?.garantorDeclaration?.docId || guarantorDeclarations?.docId || null;

      if(docId)
      {
        setGuarantorDeclarationUploaded(true)
      }
                      
  },[])
  return (
    <div className="row">
      <div className="">
        <div className="card">
          <div className="card-header">
            <h6 className="card-title">{language.guarantors_details}</h6>
          </div>
          <div className="card-body">
            <form>
              <h4 className="text-info">{language.guarantor_heading}</h4>

              {guarantors.map((guarantor, index) => (
                // //.log(
                //   'guarantor in map',
                //   guarantor,
                //   guarantor?.name || 'Name not defined',
                //   guarantor?.address || 'Address not defined',
                //   guarantor?.panCardNo || 'PAN Card No not defined',
                //   guarantor?.docDetail || 'DocDetail not defined'
                // ),
                <div key={index} className="border p-3 mb-3">
                  <h5 className="text-primary">{`Guarantor ${index + 1}`}</h5>

                  {/* Name Input */}
                  <div className="mb-3">
                    <label className="col-form-label">{formLanguage.name} ({language.name}) <span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      value={guarantor?.name || ''}
                      onChange={(e) => handleInputChange(index, e)}
                      required
                    />
                   {errors?.guarantors?.[index]?.name && (
                    <div className="d-block invalid-feedback">
                      {errors.guarantors?.[index]?.name}
                    </div>
                  )}
                  </div>

                  {/* Address Input */}
                  <div className="mb-3">
                    <label className="col-form-label">{formLanguage.address} ({language.address}) <span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      name="address"
                      value={guarantor?.address || ''}
                      onChange={(e) => handleInputChange(index, e)}
                      required
                    />
                    {errors?.guarantors?.[index]?.address && (
                    <div className="d-block invalid-feedback">
                      {errors.guarantors[index].address}
                    </div>
                  )}
                  </div>

                  {/* PAN Card No Input */}
                  <div className="mb-3">
                    <label className="col-form-label">{formLanguage.pan_card_no}( {language.pan_card_no}) <span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      name="panCardNo"
                      value={guarantor?.panCardNo || ''}
                      onChange={(e) => handleInputChange(index, e)}
                      required
                    />
                      {errors?.guarantors?.[index]?.panCardNo && (
                    <div className="d-block invalid-feedback">
                      {errors.guarantors[index].panCardNo}
                    </div>
                  )}
                  </div>

                  {/* File Uploads */}
                  <h4 className="text-info mb-4 mt-4">Upload Supporting Documents:</h4>
                  {fields.map((field) => {
                    const docName = `${field}_${index + 1}`;
                    const uploadedDoc = guarantors[index]?.docDetail?.find(
                      (doc) => doc.documentName === docName
                    );

                    return (
                      <div className="mb-3" key={docName}>
                        <label className="col-form-label">
                          {language[field] || field} <span className="text-danger">*</span>
                        </label>
                        <p className="text-danger mb-1">{language.file_type}</p>
                        <input
                          type="file"
                          required
                          accept=".pdf, .jpeg, .jpg"
                          className="form-control"
                          onChange={(e) => {
                            const existingDoc =
                              existData?.docs?.find((doc: any) => doc.documentName === docName);

                              const existingDocFromGuarantors =
                              guarantors?.[index]?.docDetail?.find((doc) => doc.documentName === docName);

                              const docId = existingDoc?.id || existingDocFromGuarantors?.docId;

                              handleFileChange(e, docName, index, docId);
                          }}
                        />

                    
                        {uploadedDoc?.fileName && (
                          <div className="mt-1">
                            <small className="">Uploaded: {uploadedDoc.fileName}</small>
                          </div>
                        )}

                  
                        {errors?.guarantors?.[index]?.docDetail &&
                          errors.guarantors[index].docDetail.includes(field) && (
                            <p className="text-danger">{guarantorLabels[field]} is required</p>
                          )}
                      </div>
                    );
                  })}

                </div>
              ))}
                      <div className="mb-3" key={`guarantorDeclaration`}>
                      <label className="col-form-label">{language["guarantorDeclaration"] || `guarantorDeclaration`}  <span className="text-danger">*</span></label>
                      <div className="d-flex align-items-center">
                  {/* Dropdown for language selection */}
                      <select
                        className="form-select w-auto me-2"
                        onChange={(e) => setSelectedLang(e.target.value)}
                      >
                        <option value="">Select Language For Download</option>
                        <option value="english">English</option>
                        <option value="gujarati">Gujarati</option>
                      </select>
 
                  {/* Download Button */}
                      <button
                        type="button"
                        className="btn btn-link text-danger"
                        onClick={() => {
                          if (!selectedLang) {
                            // alert("Please select a language");
                            toast.info("Please select a language", {position: "top-right", autoClose: 3000,});
                            
                            return;
                          }
                          handleDownload(
                            selectedLang === "english"
                              ? ["GuarantorDeclaration.pdf"]
                              : ["guarantor_declaration_inGujarati.pdf"]
                          );
                        }}
                      >
                        <span className="text-danger">Download</span>{" "}
                        <i
                          className="fa fa-file-pdf"
                          data-bs-toggle="tooltip"
                          title="Download Sample"
                        />
                      </button>
                </div>
 
                      {/* <input
                        type="file"
                        className="form-control"
                        onChange={(e) =>{ 
                        
                          handleFileChange(e, `guarantorDeclaration`,1)}}
                      />
                        {existData && existData.docs?.find((doc: any) => doc.documentName === "guarantorDeclaration")?.fileName && (
                          <p>Uploaded File: {existData.docs.find((doc: any) => doc.documentName === "guarantorDeclaration")?.fileName}</p>
                          )} */}

                     
                      <input
                        type="file"
                        className="form-control"
                        accept=".pdf, .jpeg, .jpg"
                        // onChange={(e) =>{ 
                        //   if(existData && existData?.garantorDeclaration?.docId){
                        //     handleFileChange(e, `guarantorDeclaration`,1,existData?.garantorDeclaration?.docId)
                        //   }else{                                                                      

                        //     handleFileChange(e, `guarantorDeclaration`,1)     
                            
                        //   }
                        //   }}
                        onChange={(e) => {
                          const docId =
                            existData?.garantorDeclaration?.docId || guarantorDeclarations?.docId || null;
                      
                          handleFileChange(e, "guarantorDeclaration", 1, docId);
                        }}
                        />
                      
                        {existData  && existData?.garantorDeclaration?.fileName ? (
                          <p>Uploaded File: {existData?.garantorDeclaration?.fileName}</p>
                        ) : (
                          null
                        )}
                      {errorr.gurantorDeclaration && <p style={{ color: "red" }}>{errorr.gurantorDeclaration}</p>}

                        {/* {fileError["guarantorDeclaration"] && (
                          <p className="text-danger">{fileError["guarantorDeclaration"]}</p>
                        )} */}
                           {/* {errors?.guarantorDeclaration && (
                            <p className="text-danger">{errors.guarantorDeclaration}</p>
                          )} */}
                    
                     </div>


                <div className="form-check mt-4">
               
        {/* <label htmlFor="declaration" className="form-check-label fw-bold">
          I have checked the application and it has been approved from my end
        </label> */}
          <div style={{ fontFamily: "Gujarati, sans-serif", lineHeight: "1.8", padding: "1rem" }}>
          <input
                  type="checkbox"
                  id="declaration"
                  className="form-check-input"
                  checked={isChecked}
                  onChange={() => setIsChecked(!isChecked)}
                />
      {errorr.electionContest && <p style={{ color: "red" }}>{errorr.electionContest}</p>}

            <h2 style={{ textAlign: "center", fontWeight: "bold", marginBottom: "1rem" }}>
              બાંહેઘરી / પ્રમાણપત્ર
            </h2>

            <p>
              હું/અમો બાહેંધરી આપુ છું/આપીએ છીએ કે, ગુજરાત ખેત ઉત્પન્ન અને બજાર (ઉતેજન અને સરલીકરણ) 
              અધિનિયમ–૧૯૬૩ની કલમ-11 (ii) અને (iii) હેઠળ પુરી પાડવામાં આવેલ વ્યવસાયનું મુખ્ય સૈઘ્ઘાંતિક સ્થળ
              <span style={{ borderBottom: "1px dotted black", margin: "0 0.5rem" }}>{existData?.department?.District}</span>
              છે. જે અન્વયે બજાર સમિતિ -
              <span style={{ borderBottom: "1px dotted black", margin: "0 0.5rem" }}>{existData?.department?.apmcName}</span>
              માંથી વેપારી તરીકે એકવિધ (યુનિફાઈડ) લાયસન્સ મેળવવા માટે કરેલ અરજી કરેલ છે.
            </p>

            <p>
              હું/અમો આથી બાહેંધરી આપુ છું/આપીએ છીએ કે, મારી / અમારી અરજી અન્વયે મંજુર થયેલ યુનિફાઇડ વેપારી
              લાયસન્સથી મળેલ મત્તાધિકારનો ઉપયોગ અને પ્રતિનિધિત્વ મારી / અમારી અરજીમાં જણાવેલ ખેતીવાડી ઉત્પન્ન બજાર
              સમિતિ :
              <span style={{ borderBottom: "1px dotted black", margin: "0 0.5rem" }}>{existData?.department?.apmcName}</span>
              (વેપારી મત વિભાગ) માં જ કરીશ / કરીશું. જેની બાહેંધરી આપુ છું / આપીએ છીએ. તેમજ રાજયની બીજી કોઇપણ બજાર
              સમિતિ માટે પાત્ર થશે નહિ. જેની અમોને જાણ છે. જે બદલ આ બાંહેઘરી / પ્રમાણપત્રમાં નીચે સહી કરી આપીએ છીએ.
            </p>

            <p style={{ marginTop: "2rem" }}>
              તારીખ :- <span style={{ borderBottom: "1px dotted black", marginLeft: "0.5rem" }}>{formattedDate}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <br />
              સ્થળ :- <span style={{ borderBottom: "1px dotted black", marginLeft: "0.5rem" }}>{existData?.department?.District}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            </p>

            {/* <p style={{ textAlign: "right", marginTop: "4rem" }}>
              પૂર્ણ નામ, સહી તથા સિક્કો
            </p> */}
          </div>
      </div>    
      
              <div className="d-flex justify-content-start mt-3">
                <button type="button" className="btn btn-secondary" onClick={onPrev}>
                  {language.previous}
                </button>
              </div>
              <div className="d-flex justify-content-end mt-3">
                <button type="button" className="btn btn-primary" onClick={handleNext}>
                  {language.next}
                </button>
                </div>
                {/* <ToastContainer position="top-center" autoClose={3000} /> */}
                
            </form>
          </div>
        </div>
      </div>
     
      {(uploadingFields || loading) && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-25"
          style={{ zIndex: 9999 }}
        >
          <div className="d-flex align-items-center px-4 py-3 bg-white rounded shadow">
            <div
              className="spinner-border text-primary me-3"
              role="status"
            />
            <span className="fw-semibold text-dark">
              {uploadingFields ? "Uploading..." : "Submitting..."}
            </span>
          </div>
        </div>
      )}                                                                                                                                                                                  
    </div>
  );
};

export default Guarantors;

